/** @jsxImportSource @emotion/react */
import { TruncatedString } from '@quickbit/backoffice-core-frontend';
import {
  Loader,
  Table,
  Typography,
  useTheme,
} from '@quickbit/qb-design-system';
import { ProcessingUserAlgorandTransactionsResponse } from '../../api';

interface Props {
  data?: ProcessingUserAlgorandTransactionsResponse;
  isLoading: boolean;
}

export const AlgorandProcessingTransactions = ({ data, isLoading }: Props) => {
  const { palette } = useTheme();

  if (isLoading) {
    return <Loader />;
  }

  if (!data || data.transactions.length === 0) {
    return (
      <Typography variant="subtitle" color={palette.grey.x300}>
        No Algorand processing transactions found for this user.
      </Typography>
    );
  }

  return (
    <Table
      headers={[
        { label: 'Created At', cellKey: 'createdAt', sort: false },
        { label: 'Status', cellKey: 'status', sort: false },
        {
          label: 'Blockchain Transaction ID',
          cellKey: 'blockchainTransactionId',
          sort: false,
        },
        { label: 'Amount (ALGO)', cellKey: 'amount', sort: false },
        {
          label: 'Network Fee (ALGO)',
          cellKey: 'networkFee',
          sort: false,
        },
        {
          label: 'Sender Address',
          cellKey: 'senderAddress',
          sort: false,
        },
        {
          label: 'Receiver Address',
          cellKey: 'receiverAddress',
          sort: false,
        },
      ]}
      rows={data.transactions.map((transaction) => ({
        value: {
          createdAt: transaction.createdAt.toLocaleString(),
          status: transaction.status,
          blockchainTransactionId: (
            <TruncatedString text={transaction.blockchainTransactionId} />
          ),
          amount: transaction.amount,
          networkFee: transaction.networkFee,
          senderAddress: <TruncatedString text={transaction.senderAddress} />,
          receiverAddress: (
            <TruncatedString text={transaction.receiverAddress} />
          ),
        },
      }))}
    />
  );
};
